import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import {
  borderWidth,
  borderStyle,
} from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Sidebar = styled.nav<{ $isCollapsed: boolean }>`
  display: flex;
  flex-direction: column;
  width: ${({ $isCollapsed }) => ($isCollapsed ? "52px" : "220px")};
  height: 100%;
  background: ${rawColors.structural.white};
  border: ${borderWidth[1]} ${borderStyle.solid} ${rawColors.grey[200]};
  border-radius: 16px;
  flex-shrink: 0;
  transition: width 0.2s ease;
  overflow: hidden;
`;

export const Header = styled.div<{ $isCollapsed: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $isCollapsed }) => ($isCollapsed ? "center" : "space-between")};
  padding: ${spacing[3]} ${({ $isCollapsed }) => ($isCollapsed ? spacing[2] : spacing[4])};
  border-bottom: ${borderWidth[1]} ${borderStyle.solid} ${rawColors.grey[200]};
`;

export const HeaderLabel = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.mediumEmphasis};
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

export const CollapseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: ${borderWidth[1]} ${borderStyle.solid} ${rawColors.grey[200]};
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  color: ${rawColors.grey[600]};
  padding: 0;

  &:hover {
    background: ${rawColors.grey[100]};
    color: ${rawColors.grey[900]};
  }
`;

export const NavList = styled.ul`
  list-style: none;
  margin: 0;
  padding: ${spacing[2]} 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  overflow-y: auto;
`;

export const NavItem = styled.li<{ $isActive: boolean; $isCollapsed?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $isCollapsed }) => ($isCollapsed ? "center" : "flex-start")};
  gap: ${spacing[3]};
  padding: ${spacing[2]} ${({ $isCollapsed }) => ($isCollapsed ? spacing[2] : spacing[4])};
  border-radius: 6px;
  margin: 0 ${spacing[1]};
  cursor: pointer;
  background: ${({ $isActive }) =>
    $isActive ? rawColors.primary[100] : "transparent"};
  color: ${({ $isActive }) =>
    $isActive ? rawColors.primary[500] : rawColors.text.mediumEmphasis};
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${({ $isActive }) =>
      $isActive ? rawColors.primary[100] : rawColors.grey[100]};
    color: ${({ $isActive }) =>
      $isActive ? rawColors.primary[500] : rawColors.text.highEmphasis};
  }

  svg {
    flex-shrink: 0;
  }
`;

export const NavLabel = styled.span<{ $isActive: boolean }>`
  ${({ $isActive }) => ($isActive ? typographyMixin("body", 2) : typographyMixin("body", 4))}
  color: ${({ $isActive }) =>
    $isActive ? rawColors.primary[500] : rawColors.text.highEmphasis};
  white-space: nowrap;
`;
